<template>
    <Dashboard />
</template>

<script>
import Dashboard from "@/components/dashboard/Dashboard.vue";

export default {
    name: "dashboard",
    components: {
        Dashboard,
    },
};
</script>